import styled from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import ProductCarouselWidgetWithEvents from 'ggApp/shared/components/widgets/productCarouselWidget';
import { CategoryWidgetWithEvents } from 'ggApp/shared/components/widgets/CategoryWidget';

export const ProductCarousel = styled(ProductCarouselWidgetWithEvents)`
    @media (${screens.phone}) and (${screens.tabletMax}) {
        margin-right: -32px;
    }
`;

export const CategoryWidget = styled(CategoryWidgetWithEvents)`
    grid-column: auto / span 6;
    margin-bottom: 32px;

    @media (${screens.phone}) and (${screens.tabletMax}) {
        grid-column: 1 / -1;
    }

    @media (${screens.phone}) and (${screens.desktopMax}) {
        margin-bottom: 24px;
    }
`;
